import React                   from 'react';
import { Observe }                  from 'rewire-core';
import employeeTimeOffTypeViewModel from './EmployeeTimeOffTypeViewModel';
import TimeOffRequestHistoryView    from './TimeOffRequestHistoryView';
import TimeOffTypeTransactionsView  from './TimeOffTypeTransactionsView';

const EmployeeTimeOffTypeView = React.memo(() => {
  return (
    <Observe render={() => {
      return employeeTimeOffTypeViewModel.isView('transactionDetails')
        ? <TimeOffTypeTransactionsView />
        : <TimeOffRequestHistoryView />;
    }} />
  );
});

export default EmployeeTimeOffTypeView;
